import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Pagination from '@mui/material/Pagination';
import EditIcon from '@mui/icons-material/Edit';
import PeopleIcon from '@mui/icons-material/People';
import { useNavigate } from 'react-router-dom';

import { showDangerToast, showToast } from '../../constants/toaster';
import { uplodateLoading, updateGrades, clearGradesCache } from '../../../redux/features/common/commonSlice';
import { selectGradesPages, selectGradesIsLoaded, selectGradesPagerecord } from '../../../redux/features/common/selectors';
import ApiCaller from '../../constants/ApiCaller';
import urls from '../../constants/apiurl';
import NoDataImg from '../../../assets/img/no-data.gif';
import { Button } from '@mui/material';
import AddGradeModal from './AddGradeModal';
import "./app.css";
export const GradeList = props => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userData = useSelector(state => state.userData);

    const LOADING_ENABLE = useSelector(state => state.loading);
    const [selectedGrade, setSelectedGrade] = useState(null);

    const [page, setPage] = useState(1);
    const [pageInput, setPageInput] = useState(1);

    const pages = useSelector(selectGradesPages);
    const grades = pages[page] || [];
    const pagerecord = useSelector(selectGradesPagerecord);
    const isLoaded = useSelector(selectGradesIsLoaded);

    const [modalOpen, setModalOpen] = useState(false);

    const isInitialMount = useRef(true);

    const fetchGrades = async (silent = false, customPage = page) => {
        try {
            if (!silent) {
                dispatch(uplodateLoading(true));
            }

            const token = userData?.access_token;
            if (!token) {
                showDangerToast("Access token missing. Please log in again.");
                if (!silent) dispatch(uplodateLoading(false));
                return;
            }

            const body = {
                pageNumber: customPage - 1, // backend uses 0-based pages
                pageSize: 5
            };

            const path = "/api/admin-service/grades/grade-list";

            const res = await ApiCaller.post(body, path, token);
            const response = res?.response ? await res.response.json() : null;
            console.log("Grade List API Response:", response);

            if (response && (response.status === 200 || response.status === "200")) {
                const data = response?.data?.content || response?.data || [];
                const newPagerecord = {
                    totalItems: response?.data?.totalItems || data.length,
                    totalPages: response?.data?.totalPages || 1,
                    pageNumber: response?.data?.pageNumber || 1,
                    pageSize: response?.data?.pageSize || 5
                };
                dispatch(updateGrades({ pageNumber: customPage, content: data, pagerecord: newPagerecord }));
            } else {
                showDangerToast(response?.message || "Failed to fetch grades");
            }

        } catch (error) {
            console.error("Grade List Error:", error);
            showDangerToast(error?.message || "Error fetching grade data");
        } finally {
            if (!silent) {
                dispatch(uplodateLoading(false));
            }
        }
    };

    useEffect(() => {
        const hasCache = !!pages[page];
        fetchGrades(hasCache, page);
    }, [page]);

    const handlePageChange = (e, value) => {
        setPage(value);
        setPageInput(value);
    };

    const handlePageInputChange = (e) => {
        setPageInput(e.target.value);
    };

    const handlePageInputSubmit = () => {
        const v = Number(pageInput);
        if (v >= 1 && v <= pagerecord.totalPages) {
            handlePageChange(null, v);
        } else {
            setPageInput(page);
        }
    };

    return (
        <div className="table-responsive">
            <Button
                size="small"
                variant="outlined"
                color="secondary"
                onClick={() => navigate('/grade-change-log')}
                style={{ marginBottom: '10px', marginRight: '10px' }}
                className='btn btn-outline-dark'
            >
                Grade Change Log
            </Button>
            <Button
                variant="contained"
                onClick={() => setModalOpen(true)}
                style={{ marginBottom: '10px' }}
                className='btn btn-dark'
            >
                Add Grade
            </Button>

            <AddGradeModal
                open={modalOpen}
                onClose={() => setModalOpen(false)}
                onSuccess={() => {
                    dispatch(clearGradesCache());
                    setPage(1);
                    setPageInput(1);
                    fetchGrades(false, 1);
                }}
                token={userData.access_token}
                updatedBy={userData.emailId || userData.emailId}
            />

            {console.log("userData?.firstName:", userData)}

            <AddGradeModal
                open={modalOpen}
                onClose={() => {
                    setModalOpen(false);
                    setSelectedGrade(null); // Reset on close
                }}
                onSuccess={() => {
                    dispatch(clearGradesCache());
                    setPage(1);
                    setPageInput(1);
                    fetchGrades(false, 1);
                }}
                token={userData.access_token}
                updatedBy={userData?.id}
                editData={selectedGrade}
            />

            {console.log("userData?.firstName:", userData?.access_token)}
            {grades && grades.length > 0 ? (
                <>

                    <table className=" table table-hover align-items-center table-flush table-striped">
                        <thead className="thead-dark text-white">
                            <tr className="text-white text-center">
                                <th className='text-white text-center'>S.No</th>
                                <th className='text-white text-center'>Grade Name</th>
                                <th className='text-white text-center'>Grade Value</th>
                                <th className='text-white text-center'>User Count</th>
                                <th className='text-white text-center'>Updated By</th>
                                <th className='text-white text-center'>Actions</th>

                            </tr>
                        </thead>
                        <tbody>
                            {grades.map((g, idx) => (
                                <tr key={idx}>
                                    <td className='text-center'>{idx + 1}</td>
                                    <td className='text-center'>{g.gradeName}</td>
                                    <td className='text-center'>{g.gradeValue}</td>
                                    <td className='text-center'>
                                        {g.usersCount}
                                    </td>
                                    <td className='text-center'>{g.updatedBy}</td>
                                    <td className='text-center'>
                                        <Button
                                            size="small"
                                            variant="contained"
                                            color="primary"
                                            className="me-2"
                                            startIcon={<PeopleIcon fontSize="small" />}
                                            onClick={() => {
                                                navigate(`/users-by-grade/${g.id}`, {
                                                    state: {
                                                        gradeName: g.gradeName || g.name
                                                    }
                                                });
                                            }}
                                        >
                                            Users List
                                        </Button>
                                        <Button
                                            size="small"
                                            variant="outlined"
                                            color="secondary"
                                            onClick={() => {
                                                setSelectedGrade(g);
                                                setModalOpen(true);
                                            }}
                                        >
                                            <EditIcon fontSize="small" />
                                        </Button>
                                    </td>

                                </tr>
                            ))}
                        </tbody>
                    </table>
                </>
            ) : (
                <div className="text-center">
                    <img width={'25%'} src={NoDataImg} alt="No Data" />
                    <br />
                    <label style={{ fontWeight: 'bold' }}>
                        {LOADING_ENABLE ? 'Loading Data...' : 'No Data Found'}
                    </label>
                </div>
            )}
            {grades && grades.length > 0 && (
                <div className="card-footer py-4">
                    <Box display="flex" justifyContent="right" alignItems="center">
                        <span>Total record: {grades.length}</span>
                        <TextField
                            label="Go to page"
                            type="number"
                            inputProps={{ min: 1, max: pagerecord.totalPages }}
                            value={pageInput}
                            onChange={handlePageInputChange}
                            onBlur={handlePageInputSubmit}
                            onKeyDown={(e) => e.key === "Enter" && handlePageInputSubmit()}
                            size="normal"
                            sx={{ mx: 2 }}
                        />
                        <Pagination
                            count={pagerecord.totalPages}
                            page={page}
                            onChange={handlePageChange}
                            color="secondary"
                        />
                    </Box>
                </div>
            )}
        </div>
    );
};
